<template>
  <div class="loader-container">
    <div class="loader">&nbsp;</div>
    <p class="mt-3 scss-bold">Please Wait</p>
  </div>
  <div class="transparent-cover">&nbsp;</div>
</template>

<script>
export default {
  name: "LoadingSpinner",
  props: {},
  components: {},
};
</script>

<style lang="scss" scoped>
.loader-container {
  padding: 30px 45px 10px 45px;
  z-index: 9999;
  position: fixed;
  background-color: #fff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  box-shadow: 0 4px 10px #605f5f;
}
.loader,
.loader:after {
  border-radius: 50%;
  width: 8em;
  height: 8em;
}
.loader {
  font-size: 10px;
  text-indent: -9999em;
  border-top: 0.5em solid #9bc5ff;
  border-right: 0.5em solid #9bc5ff;
  border-bottom: 0.5em solid #9bc5ff;
  border-left: 0.5em solid #579eff;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 0.8s infinite linear;
  animation: load8 0.8s infinite linear;
  margin: auto;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.transparent-cover {
  background: rgb(23, 23, 23);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.3;
  height: 100%;
  z-index: 9998;
  overflow: hidden;
}

html,
body {
  height: 100%;
  overflow: hidden;
  margin: 0;
}
</style>
